const $inject = [];

const inputUppercase = function () {
  return {
    require: 'ngModel',
    link: function (scope, elem, attrs, ctrl) {
      const capInputText = (inputText) => {
        const value = (inputText || '').toString().toUpperCase();

        if (value !== inputText) {
          ctrl.$setViewValue(value);
          ctrl.$render();
        }

        return value;
      };

      // the second line is used to capitalize the initial value.
      ctrl.$parsers.push(capInputText);
      capInputText(scope[attrs.ngModel]);
    },
  };
};

inputUppercase.$inject = $inject;

export default inputUppercase;



// WEBPACK FOOTER //
// ./src/directives/inputUppercase.js